import { NotificationType } from 'src/@smartmanufacturing/common/enum';

export class NotificationItem {
    public timeout = 5000;

    constructor(
        public id: string = '',
        public title: string = '',
        public body: string = '',
        public type: NotificationType = null,
        public isRead: boolean = false,
        public elementId: string = '',
        public createdAt: string = ''
    ) {

    }

    toJson() {
        return JSON.stringify(this);
    }
}
